import { DateTime } from 'luxon'
import { AdvancedCareTeamMember } from '../../api/types'

export const isActiveCareTeamMember = ({ startedAt, endedAt }: AdvancedCareTeamMember) => {
  const now = DateTime.now()
  return DateTime.fromISO(startedAt) <= now && (endedAt === null || DateTime.fromISO(endedAt) > now)
}
